import { render, staticRenderFns } from "./ConfiguratorMain.vue?vue&type=template&id=50129424&scoped=true&"
import script from "./ConfiguratorMain.vue?vue&type=script&lang=ts&"
export * from "./ConfiguratorMain.vue?vue&type=script&lang=ts&"
import style0 from "./ConfiguratorMain.vue?vue&type=style&index=0&id=50129424&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50129424",
  null
  
)

export default component.exports